import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";

import Header from "./Shared/Header";
import Home from "./Pages/Home/Home/Home";

import Footer from "./Shared/Footer";
import AbboutMe from "./Pages/Home/AbboutMe/AbboutMe";
import MyAllProjects from "./Pages/Home/MyAllProjects/MyAllProjects";
import Blog from "./Pages/Home/Blog/Blog";
import MyContact from "./Pages/Home/MyContact/MyContact";
import ParticleBackground from "./ParticleBackground/ParticleBackground";
import { useEffect } from "react";
import { useState } from "react";
import { Circle2 } from "react-preloaders";

function App() {
   const [load, setLoad] = useState(true);

   // useEffect(() => {
   //    const timer = setTimeout(() => {
   //       setLoad(false);
   //    }, 1200);

   //    return () => clearTimeout(timer);
   // }, []);
   return (
      <div className="App">
         
         <Router>
            <ParticleBackground></ParticleBackground>
            <Header></Header>

            <Routes>
               <Route path="/home" element={<Home></Home>} />
               <Route path="/about" element={<AbboutMe></AbboutMe>}></Route>
               <Route
                  path="/projects"
                  element={<MyAllProjects></MyAllProjects>}
               />
               <Route path="/blog" element={<Blog></Blog>} />
               <Route path="/contact" element={<MyContact></MyContact>} />
               <Route exact path="/" element={<Home></Home>}></Route>
            </Routes>
            <Footer></Footer>
         </Router>
      </div>
   );
}

export default App;
